import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import ComingSoon from './components/ComingSoon';
import Courses from './components/Courses';
import CourseDetail from './components/CourseDetail';
import Home from './components/Home';
import Resume from "./components/Resume";

function AppContent() {
  const location = useLocation();

  // Reveal animations
  useEffect(() => {
    const elements = document.querySelectorAll('.revealable');

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [location]);

  // ⭐ Apply resume-body class ONLY on /resume
  useEffect(() => {
    if (location.pathname === "/resume") {
      document.body.classList.add("resume-body");
    } else {
      document.body.classList.remove("resume-body");
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/products" element={<ComingSoon />} />
      <Route path="/courses" element={<Courses />} />
      <Route path="/courses/:slug" element={<CourseDetail />} />
      <Route path="/resume" element={<Resume />} />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
